export const formatImportErrorLine = (entry, t) => {
    if (entry == null) return "";
    if (typeof entry === "string") return entry;
    const rowLabel = typeof t?.read === "function" ? (t.read("row") || "Row") : "Row";
    const parts = [];
    if (entry.row != null) parts.push(`${rowLabel} ${entry.row}`);
    if (entry.field) parts.push(String(entry.field));
    if (entry.message) parts.push(String(entry.message));
    return parts.length > 0 ? parts.join(" — ") : "";
};

export const buildImportSummaryLines = (result, t, summarySpec) => {
    const s = result?.summary ?? {};
    return summarySpec
        .map(({ key, labelKey }) => `${s[key] ?? 0} ${t.read(labelKey)}`)
        .join("\n");
};
